import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs/Subject';

@Injectable()
export class ManageChildHeadersService {
  // Observable sources
  private headerStatusSource=new Subject<number>();
  
 
  // Observable streams
  headerStatusPassed$=this.headerStatusSource.asObservable();  
 
  // Service message commands
  setHeaderStatus(newStatus: number) {
    this.headerStatusSource.next(newStatus);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/manage-child-headers.service.ts